import partnerClient from "../partnerClient";

export const fetchPartnerLeads = async (params) => {
  const { data } = await partnerClient.get("/leads", { params });
  return data?.data ?? data;
};

export const fetchPartnerLead = async (id) => {
  const { data } = await partnerClient.get(`/leads/${id}`);
  return data?.data ?? data;
};

export const createPartnerLead = async (payload) => {
  const { data } = await partnerClient.post("/leads", payload);
  return data?.data ?? data;
};

export const updatePartnerLead = async (id, payload) => {
  const { data } = await partnerClient.put(`/leads/${id}`, payload);
  return data?.data ?? data;
};

export const issueLeadShareLink = async (id) => {
  const { data } = await partnerClient.post(`/leads/${id}/share-link`);
  return data?.data ?? data;
};

export const emailLeadShareLink = async (id, message) => {
  const { data } = await partnerClient.post(`/leads/${id}/email-link`, {
    message: message || null,
  });
  return data?.data ?? data;
};

export const fetchLeadForm = async (id) => {
  const { data } = await partnerClient.get(`/leads/${id}/form`);
  return data?.data ?? data;
};

export const saveLeadForm = async (id, values) => {
  const { data } = await partnerClient.put(`/leads/${id}/form`, { values });
  return data?.data ?? data;
};

export const confirmPartnerLead = async (id) => {
  const { data } = await partnerClient.post(`/leads/${id}/confirm`);
  return data?.data ?? data;
};
